import {
  composeSDKFactories,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  createElementPropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';

import {
  stylableButtonSDKFactory,
  accessibilityPropsSDKFactory,
} from '../../../StylableButton/corvid/StylableButton.corvid';

import type {
  IHamburgerCloseButtonOwnSDKFactory,
  IHamburgerCloseButtonProps,
  IHamburgerCloseButtonSDK,
} from '../HamburgerCloseButton.types';

export const hamburgerCloseButtonCorvidType = '$w.HamburgerCloseButton';

const hamburgerCloseButtonSDKFactory: IHamburgerCloseButtonOwnSDKFactory =
  () => {
    return {
      get type() {
        return hamburgerCloseButtonCorvidType;
      },
    };
  };

const elementPropsSDKFactory = createElementPropsSDKFactory();

export const sdk = composeSDKFactories<
  IHamburgerCloseButtonProps,
  IHamburgerCloseButtonSDK
>([
  elementPropsSDKFactory,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  accessibilityPropsSDKFactory,
  stylableButtonSDKFactory,
  hamburgerCloseButtonSDKFactory,
]);

export default createComponentSDKModel(sdk);
